export const COOKIE_HREF = '/about/privacy-policy/#cookie';
